<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "StackedBarChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] }),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.labels || !this.chartData.datasets) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");

      const datalabelsPlugin = {
        id: 'stackedDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          const datasets = chart.data.datasets;
          const meta = chart.getDatasetMeta(datasets.length - 1);

          meta.data.forEach((bar, index) => {
            // Calculate total for this bar (sum of all datasets at this index)
            const total = datasets.reduce((sum, dataset) => {
              return sum + (dataset.data[index] || 0);
            }, 0);

            if (total === 0) return;

            ctx.save();
            ctx.fillStyle = '#2e4664';
            ctx.font = 'bold 11px sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.fillText(total, bar.x, bar.y - 5);
            ctx.restore();
          });
        },
      };

      const legendMarginPlugin = {
        id: 'legendMargin',
        beforeInit(chart) {
          const originalFit = chart.legend.fit;
          chart.legend.fit = function fit() {
            originalFit.bind(chart.legend)();
            this.height += 20;
          };
        },
      };

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.chartData.labels,
          datasets: this.chartData.datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
          },
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
              },
            },
            y: {
              stacked: true,
              beginAtZero: true,
            },
          },
        },
        plugins: [datalabelsPlugin, legendMarginPlugin],
      });
    },
  },
};
</script>
